import { withParams } from 'vuelidate/lib';
import { isValid } from 'ipaddr.js';

export default withParams({ type: 'ip' }, (value) => {
  if (!value) {
    return true;
  }

  return isValid(value);
});
